import { ComponentProps, ReactNode } from 'react'
import { Badge } from '~/elements'
import { cn } from '~/utils'

type Props = {
  label: ReactNode
  value: ReactNode
  clickable?: boolean
} & ComponentProps<typeof Badge>

export const Tag = ({ label, value, color = 'neutral', clickable, ref, className, ...props }: Props) => {
  return (
    <Badge
      ref={ref}
      variant="secondary"
      color={color}
      {...props}
      className={cn(clickable && `cursor-pointer hover:bg-${color}-200!`, className)}
    >
      <span className={cn('font-semibold', `text-${color}-800`)}>{label}</span>
      <span className="truncate">{value}</span>
    </Badge>
  )
}
